
$(document).ready(function(){
  
  //Renvoie le lien vers les politiques FR
  //Au click sur le lien des politiques de confidentialité, on update si on est en page artiste
  $(document).on('click','a',function(){
    var current_lang = $('html').attr('lang');
    if(current_lang == 'fr') {
      if ($(this).hasClass('isense-cc-link')) {
        var sc_policies_link = $(this).attr('href');
        var new_policies_link = sc_policies_link.replace('/policies/', '/fr/policies/');
        $(this).attr('href',new_policies_link);
      }
    }
  });

})